module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-icon1.ed58b4cb.png";